"use client";

import { useQueryHandler } from "@/hooks/use-query-handler";
import { NoQuery } from "../no-query";
import { DraftSummaryCard } from "./draft-summary-card";
import { NoResult } from "../no-result";

function DraftSearchQueryResults() {
  const { query } = useQueryHandler();

  const data = query ? ["WIP"] : null; //TODO:

  if (query === undefined) {
    return (
      <NoQuery
        title="Rechercher un brouillon"
        description="Saisissez un ID, un numéro VIN, un modèle ou un nom client pour consulter les brouillons."
      />
    );
  }

  if (data?.length === 0) return <NoResult query={query} />;

  return (
    <div className="space-y-4">
      {Array.from({ length: 5 }).map((_, index) => (
        <DraftSummaryCard
          key={index}
          name="DRAFT-001"
          kvps="FRAA02063"
          vehiculeName="Golf 8 GTI"
          vehiculeVin="WVWZZZ1JZ3W123456"
          client="Jean Dupont"
          lastModified={new Date()}
          expiryDate={new Date()}
          currentStep={3}
          author="Pierre Dubois"
          createdAt={new Date()}
        />
      ))}
    </div>
  );
}

export { DraftSearchQueryResults };
